import TOOLS from '@helpers/tools'
import FILTERS from '@helpers/filters'
import slugify from 'slugify'
import { isEmpty } from 'lodash'

export default function genericModalDataLayer(product, locations, region, contactType, elementText) {
  const timeStamp = Date.now()
  let dataLayer = window['dataLayer']

  if (dataLayer) {
    let ecommerce, imoveis
    if (product) {
      let nome = slugify(product.Nome),
        estado = slugify(product.Localizacao.Estado),
        cidade = slugify(product.Localizacao.Cidade),
        bairro = slugify(product.Localizacao.Bairro),
        quartos = slugify(product.Quartos),
        areaPrivativa = isEmpty(product.AreaPrivativaM2) ? undefined : slugify(product.AreaPrivativaM2),
        marca = 'vivaz',
        preco = FILTERS.moneyBi(product.PrecoMinimo)
      ecommerce = {
        purchase: {
          actionField: {
            id: `${timeStamp}`,
          },
          products: {
            id: `${product.imovelId}`,
            name: `${nome}`,
            brand: `${marca}`,
            category: `${estado}/${cidade}`,
            variant: `${bairro}/${quartos}/${areaPrivativa}`,
            price: `${preco}`,
          },
        },
      }
      imoveis = {
        id: product.imovelId,
        nome: nome,
        bairro: bairro,
        cidade: cidade,
        estado: estado,
        areaprivativa: areaPrivativa ? areaPrivativa : undefined,
        dormitorios: quartos,
        vagas: product.VagasGaragem,
        valor: preco ? preco : undefined,
        status: product.Status ? TOOLS.slugify(product.Status) : undefined,
        position: undefined,
      }
    } else {
      ecommerce = {
        purchase: {
          actionField: {
            id: `${timeStamp}`,
          },
          products: {
            id: 'na',
            name: 'na',
            brand: 'vivaz',
            category: 'na',
            variant: 'na',
            price: 1,
          },
        },
      }
      imoveis = undefined
    }
    let nameState = locations.find(x => +x.idEstado === +region)
    let nameCity = !!nameState ? nameState.filtroCidade[0].nomeCidade : ''

    let datalayerRegion = TOOLS.getCityState(locations, region)
    dataLayer.push({ imoveis: undefined })
    dataLayer.push({
      'event': 'purchase',
      'eventCategory': 'form-contato',
      'eventAction': `${elementText}:submit`,
      'eventLabel': `footer:${contactType}:${elementText}:${timeStamp}`,
      ecommerce,
      'estado': datalayerRegion ? TOOLS.slugify(datalayerRegion.nome) : nameState,
      'cidade': datalayerRegion ? TOOLS.slugify(datalayerRegion.filtroCidade[0].nomeCidade) : nameCity,
      'contato': {
        'objetivo': elementText,
        'forma': contactType,
        'id': `${timeStamp}`,
      },
      imoveis,
    })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/BI/genericModalDataLayer.js